/* Touma — scroll reveal + silent video guarantee.
   One observer, no dependencies, no layout shift. */
(function () {
  'use strict';

  /* ---- Every video on the site is a living image, never a player ---- */
  function silence() {
    document.querySelectorAll('video').forEach(function (video) {
      video.muted = true;
      video.defaultMuted = true;
      video.volume = 0;
      video.removeAttribute('controls');
      video.setAttribute('playsinline', '');
      if (video.autoplay && video.paused) {
        var attempt = video.play();
        if (attempt && attempt.catch) attempt.catch(function () {});
      }
    });
  }

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function collect() {
    var sections = document.querySelectorAll('.shopify-section');
    var targets = [];

    sections.forEach(function (section, index) {
      if (section.closest('#shopify-section-group-header-group')) return;
      if (section.closest('#shopify-section-group-footer-group')) return;
      if (section.querySelector('.touma-lang, .announcement-bar, header')) return;
      if (index === 0) return;

      var rect = section.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.85) return;

      section.classList.add('touma-reveal');
      targets.push(section);
    });

    return targets;
  }

  function start() {
    silence();
    window.setTimeout(silence, 1200);

    if (reduce || !('IntersectionObserver' in window)) return;

    var targets = collect();
    if (!targets.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });

    targets.forEach(function (target) { observer.observe(target); });

    window.setTimeout(function () {
      targets.forEach(function (target) { target.classList.add('is-visible'); });
    }, 6000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
